// Displays a Rails/Inertia validation error next to the field it belongs to.
//
// Not a duplicate of `components/ui/form`'s `FormMessage`: that component
// reads from react-hook-form's `useFormField` context, which this app's
// Inertia pages do not use. Page-level forms here are `useForm` from
// `@inertiajs/react`, whose `errors` bag is a plain
// `Record<string, string | string[]>` (see .claude/rules/inertia.md's
// "Forms in Pages" section) -- an ActiveModel error can arrive as a single
// message or an array of them. This primitive is the one place that shape
// is normalized and rendered.
function errorMessage(value?: string | string[]): string | null {
  if (!value) return null
  return Array.isArray(value) ? value[0] : value
}

function FieldError({ error }: { error?: string | string[] }) {
  const message = errorMessage(error)
  if (!message) return null

  return <p className="text-sm font-medium text-destructive">{message}</p>
}

export { FieldError, errorMessage }
